<template>
  <div
    class="admin-field-fulfillment-slot-picker"
    :style="containerStyles"
    @click="isFocused = true"
  >
    <v-btn v-if="focusedAndEmpty" icon small @click.stop="isFocused = false">
      <v-icon
        v-tooltip="getTooltipHtml('You must select a fulfillment type')"
        small
        >mdi-cancel</v-icon
      >
    </v-btn>
    <AdminInputSingleSelect
      v-else
      @keydown.esc="save"
      @change="save"
      @focus:change="isFocused = $event"
      @blur="isFocused = false"
      :items="fulfillmentSlots"
      v-bind="{ ...$attrs, ...$props }"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Model } from '@vuex-orm/core'
import AdminInputSingleSelect from '@/components/AdminInputSingleSelect'
export default {
  name: 'AdminCellFulfillmentSlotPicker',
  components: { AdminInputSingleSelect },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    fulfillmentType: {
      type: String,
      default: null,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      isFocused: false,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopDetail', 'getFulfillmentSlotsList']),
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
    fulfillmentSlots() {
      return this.getFulfillmentSlotsList(this.fulfillmentType)
    }, // fulfillmentSlots
    focusedAndEmpty() {
      return (
        this.isFocused &&
        (!this.fulfillmentType || this.fulfillmentType === 'Unknown')
      )
    }, // focusedAndEmpty
  },
  methods: {
    getTooltipHtml(string) {
      return {
        content: `<div class="proxima--font">${string}</div>`,
        html: true,
      }
    }, // getTooltipHtml
    save() {
      if ('function' === typeof this.Model.updateModel) {
        if (this.value == this.theSelection) return
        const fields = { [this.fieldName]: this.theSelection }
        this.Model.updateModel(this.id, fields)
      }
    }, // save
  },
  watch: {
    isFocused(isFocused) {
      if (isFocused) {
        setTimeout(() => (this.isFocused = false), 3000)
      }
    },
  },
}
</script>
